<template>
	<v-row>
		<v-col cols="3">
			<v-text-field label="Rua" v-model="iniciado.residencial.rua" outlined></v-text-field>
        </v-col>
        <v-col cols="1">
			<v-text-field label="Numero" v-model="iniciado.residencial.numero" outlined></v-text-field>
        </v-col>
        <v-col cols="1">
			<v-text-field label="Compl" v-model="iniciado.residencial.complemento" outlined></v-text-field>
        </v-col>
		<v-col cols="2">
			<v-text-field label="Bairro" v-model="iniciado.residencial.bairro" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-text-field label="cidade" v-model="iniciado.residencial.cidade" outlined></v-text-field>
        </v-col>
		<v-col cols="2">
			<v-text-field label="estado" v-model="iniciado.residencial.estado" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-select :items="this.listaPaises" v-model="iniciado.residencial.pais" label="País" outlined></v-select>
        </v-col>
		<v-col cols="3">
			<v-text-field label="Cep" v-model="iniciado.residencial.cep" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-text-field label="Fone" v-model="iniciado.residencial.fone" outlined></v-text-field>
        </v-col>
		<v-col cols="3">
			<v-text-field label="Celular" v-model="iniciado.residencial.celular" outlined></v-text-field>
        </v-col>
	</v-row>
</template>
<script>
import { mapState } from 'vuex'
	export default{
		props:[],
		computed:{
			...mapState(['iniciado', 'listaPaises']),
		},
		data(){
			return{
			
			}
		},
		
		created(){
		}
	}
</script>
<style scoped>
	
</style>